import { datadogLogs } from "@datadog/browser-logs";
import type { ReportTokenPayload, ReportTokenResponse } from "@profile-service-types/index.ts";
import type { UseMutationOptions } from "@tanstack/vue-query";
import { useMutation, useQueryClient } from "@tanstack/vue-query";
import type { Ref } from "vue";
import { ref } from "vue";
import profileService from "@/services/profile";

const getQueryKey = (payload: Ref<ReportTokenPayload>) => ["generateReportToken", payload];

export const useGenerateReportToken = (
  useMutationOptions?: UseMutationOptions<ReportTokenResponse, Error, ReportTokenPayload>,
) => {
  const queryClient = useQueryClient();

  return useMutation<ReportTokenResponse, Error, ReportTokenPayload>({
    mutationFn: async (payload) => {
      return profileService.generateReportToken(payload);
    },
    onSuccess: async (_, variables) => {
      await queryClient.invalidateQueries({ queryKey: getQueryKey(ref(variables)) });
    },
    onError: (error) => {
      datadogLogs.logger.warn("Failed to generate report token.", {
        error: error.message,
      });
    },
    ...useMutationOptions,
  });
};
